<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">{{ $t('新建项目.项目详情') }}</span>
      <div class="head-text">
        <el-button type="primary" @click="update">{{ $t('新建项目.保存') }}</el-button>
        <el-button type="primary" @click="restore">{{ $t('新建项目.还原') }}</el-button>
      </div>
    </div>
    <el-row v-loading="loading">
      <el-col :span="6">
        <el-form ref="form" :model="ProjectInformation" label-width="150px">
          <el-form-item :label="$t('新建项目.项目照片')">
            <el-upload ref="upload2" class="avatar-uploader" :show-file-list="false" :action="actionUrl"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="tp" :headers="importHeaders"
              :on-change="handleChange">
              <img v-if="FormimageUrl" :src="FormimageUrl" class="avatar w100-h200p" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目编号')">
            <el-input :disabled="true" v-model="ProjectInformation.proj02"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目名称')">
            <el-input :disabled="true" v-model="ProjectInformation.proj03"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.BIM负责人')">
            <el-input :disabled="true" v-model="ProjectInformation.admin"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.所属分组')">
            <el-input :disabled="true" v-model="ProjectInformation.prgp02"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目简称')">
            <el-input v-model="ProjectInformation.proj07"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.合同金额')">
            <el-input v-model="ProjectInformation.proj08"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.开工日期')">
            <el-date-picker v-model="ProjectInformation.proj20" type="datetime" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('新建项目.计划竣工')">
            <el-date-picker v-model="ProjectInformation.proj21" style="width: 100%;" type="datetime"></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8" :offset="1">
        <el-form ref="form" :model="ProjectInformation" label-width="150px">
          <el-form-item :label="$t('新建项目.项目地点')">
            <el-input v-model="ProjectInformation.proj13" type="textarea"></el-input>
            <!-- <div class="container">
              <div class="dome-main">
                <div class="city-picker-selector" id="city-picker-selector1"></div>
              </div>
            </div>
            <el-input v-model="detialAdree" type="textarea"></el-input> -->
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目类型')">
            <el-select style="width: 100%" filterable v-model="ProjectInformation.proj10">
              <el-option :label="item" :value="item" v-for="item in [$t('新建项目.一次设计'), $t('新建项目.深化设计'), $t('新建项目.外包设计')]"
                :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('新建项目.服务阶段')">
            <el-input v-model="ProjectInformation.proj11" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目规模')">
            <el-input v-model="ProjectInformation.proj12" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.总体工期')">
            <el-input v-model="ProjectInformation.proj14" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.建设单位')">
            <el-input v-model="ProjectInformation.proj15" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.设计单位')">
            <el-input v-model="ProjectInformation.proj16" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.BIM耗时')">
            <el-input v-model="ProjectInformation.proj09" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.施工单位')">
            <el-input v-model="ProjectInformation.proj17" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.监理单位')">
            <el-input v-model="ProjectInformation.proj18" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8" :offset="1">
        <el-form ref="form" :model="ProjectInformation" label-width="150px">
          <el-form-item :label="$t('新建项目.总体投资')">
            <el-input v-model="ProjectInformation.proj19" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('新建项目.项目概况')">
            <el-input type="textarea" rows="29" v-model="ProjectInformation.proj23"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import {
  GetProjectManagement,
  updateProjectManagement,
} from "../../../../setAxios";
export default {
  name: "ProjectInformation",
  data() {
    return {
      actionUrl: this.$store.state.baseUrl + "/api/UpdateProjectLogo",
      importHeaders: { token: localStorage.getItem("token") },
      ProjectInformation: {},
      tp: {
        xid: localStorage.getItem("xid"),
      },
      imageUrl: "",
      FormimageUrl: null,
      loading: false,
      detialAdree: "",
    };
  },
  mounted() {
    // this.first();
  },
  methods: {
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector1").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.ProjectInformation.proj13 = selector1.getCityNameVal();
        },
      });
      var addr = this.ProjectInformation.proj13.split("/");
      if (addr.length == 2) {
        if (addr[0].trim() != "") {
          selector1.setCityVal(addr[0]);
        }
        this.detialAdree = this.ProjectInformation.proj13.split("/")[1];
      }
    },
    // 监听修改的图片
    handleChange(file, fileList) {
      //("图片监听", file, fileList);
      let id = parseInt(localStorage.getItem("xid"));
      let gid = parseInt(localStorage.getItem("gid"));
      let ss = this.$store.state.baseUrl;
      this.FormimageUrl = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess(res, file) {
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        });
        this.getData();
      }
    },
    beforeAvatarUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "png" || suffix === "jpg" || suffix === "bmp" || suffix === "tif" || suffix === "webp" || suffix === "jpeg"
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension) {
        this.$message({
          message: "上传文件只能是图片类型!",
          type: "warning",
        });
        this.loading2 = false;
      }
      if (!isLt10M) {
        this.$message({
          message: "上传文件大小不能超过10MB!",
          type: "warning",
        });
      }
      return extension && isLt10M
    },
    getData() {
      this.loading = true;
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectManagement({ params }).then((res) => {
        this.loading = false;
        //(res, "项目信息");
        this.ProjectInformation = res.Data;
        //(this.ProjectInformation);
        // 图片
        this.FormimageUrl = this.$store.state.baseUrl + res.Data.proj24;
        // this.first();
      });
    },
    // 修改项目
    update() {
      this.loading = true;
      // this.ProjectInformation.proj13 =
      //   this.ProjectInformation.proj13.split("/")[0] + "/" + this.detialAdree;
      let params = JSON.stringify(this.ProjectInformation);
      updateProjectManagement({ project: params }).then((res) => {
        if (res.Code === 1) {
          this.$message({
            message: this.$t('common.处理成功'),
            type: "success",
          });
          // 这里需要做一些处理
          this.$store.state.xidName = this.ProjectInformation.proj07;
          this.detialAdree = "";
          this.loading = false;
          this.getData();
        } else {
          this.$message.error(this.$t('common.处理失败'));
        }
      });
    },
    // 还原修改
    restore() {
      this.$message({
        type: "success",
        message: this.$t('common.处理成功')
      });
      this.getData();
    },
  },
  created() {
    this.$store.state.btnStyle = ["btns", "btns", "btnss", "btns"];
    this.getData();
  },
  computed: {
    xid() {
      return this.$store.state.xid;
    },
  },
  //监听执行
  watch: {
    xid(val) {
      this.getData();
    },
  },
};
</script>

<style lang="less">
.el-form-item {
  margin-bottom: 22px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  justify-content: start;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.dome-main {
  padding: 0px;
}

.container {
  margin: 0px;
}
</style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.w100-h200p {
  width: 100% !important;
  height: 200px !important;
}
</style>
